export default class savedSearch {

    setSavedSearch() {
        const sagasState = localStorage.getItem('persist:root');
        let state: any;
        try {
            state = JSON.parse(sagasState || '{}');
        } catch (e: any) {
            console.error('Error parsing state', e);
        }
        if (typeof (state) === 'undefined') return;

        let search: any = state.search;
        if (typeof search === 'undefined') return;
        try {
            search = JSON.parse(search);
        } catch (e: any) {
            console.error('Error parsing search', e);
        }

        localStorage.setItem('savedSearch', JSON.stringify(search?.query));
    }

    restoreSavedSearch() {
        const sagasState = localStorage.getItem('persist:root');
        let state: any;
        try {
            state = JSON.parse(sagasState || '{}');
        } catch (e: any) {
            console.error('Error parsing state', e);
        }
        if (typeof (state) === 'undefined') return;

        state = {
            ...state,
            search: this.getSavedSearch()
        }
        if (state) {
            localStorage.setItem('persist:root', state);
            window.location.href = '/';
        }
    }

    clearSavedSearch() {
        localStorage.removeItem('savedSearch');
    }

    private getSavedSearch() {
        const savedSearch = localStorage.getItem('savedSearch');
        return savedSearch;
    }
}